import { useLayoutEffect, useState } from 'react';

import { canUseDOM } from '../../utilities/can-use-dom';

const useClientLayoutEffect = canUseDOM ? useLayoutEffect : () => {};

export const useDimensions = <E extends Element = Element>() => {
  const [element, ref] = useState<E | null>(null);
  const [dimensions, setDimensions] = useState({
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
  });

  useClientLayoutEffect(() => {
    if (!element) return;

    const observer = new globalThis.window.ResizeObserver((entries) => {
      if (entries[0]) {
        setDimensions(entries[0].contentRect);
      }
    });

    observer?.observe(element);

    return () => {
      observer?.disconnect();
    };
  }, [element]);

  return [ref, dimensions] satisfies [
    typeof ref,
    Omit<DOMRectReadOnly, 'toJSON'>,
  ] as [typeof ref, Omit<DOMRectReadOnly, 'toJSON'>];
};
